const items = [
  {
    id: 'upd-1',
    date: '2026-07-30',
    time: '14:32',
    title: '某平台头部美妆博主被爆产品中含有违禁成分',
    desc: '第三方检测机构出具报告显示，该博主自创品牌的多款产品存在标签未标注的违禁成分，目前平台已下架相关商品并启动调查程序。',
    tag: '最新爆料',
  },
  {
    id: 'upd-2',
    date: '2026-07-30',
    time: '10:15',
    title: '两大MCN机构公开互诉，涉及多位知名网红',
    desc: '因竞业协议和挖角纠纷，两家头部MCN机构在社交平台公开喊话，涉及至少七位百万粉级别的签约网红，业内震动。',
    tag: '行业动态',
  },
  {
    id: 'upd-3',
    date: '2026-07-29',
    time: '22:08',
    title: '知名游戏主播因不当言论被平台禁播三个月',
    desc: '该主播在直播中发表涉及地域歧视的不当言论，引发大量网友举报，平台做出禁播三个月并扣除当月全部收益的处罚。',
    tag: '处罚公告',
  },
  {
    id: 'upd-4',
    date: '2026-07-29',
    time: '16:40',
    title: '网红夫妻档宣布离婚，商业版图分割引关注',
    desc: '两人联合运营的多个品牌账号和线下门店面临分割，估值超过三千万元的商业资产如何分配成为外界关注焦点。',
    tag: '情感八卦',
  },
  {
    id: 'upd-5',
    date: '2026-07-28',
    time: '19:22',
    title: '带货主播数据造假产业链被起底',
    desc: '调查报道揭示了一套涵盖刷量、刷评、刷单的完整灰色产业链，涉案金额巨大，相关部门已介入调查。',
    tag: '深度调查',
  },
  {
    id: 'upd-6',
    date: '2026-07-28',
    time: '11:05',
    title: '平台推出新版内容审核规则，多类内容受限',
    desc: '新规对炫富、剧本炒作、低俗内容等类型做出更严格的限制，预计将影响大量以擦边球内容吸引流量的网红账号。',
    tag: '政策动态',
  },
  {
    id: 'upd-7',
    date: '2026-07-27',
    time: '15:48',
    title: '千万粉丝网红被税务部门约谈',
    desc: '据知情人士透露，该网红因直播打赏和广告收入未依法申报纳税被约谈，涉及补缴金额或达数百万元。',
    tag: '监管动态',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">最新动态</h2>
          <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">滚动更新</span>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-0.5 bg-secondary-200"></div>

          <div className="space-y-3 md:space-y-4">
            {items.map((item) => (
              <a
                key={item.id}
                href={`#cards`}
                className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14 pr-4 py-4 bg-background-50 rounded-lg border border-secondary-200/60 hover:border-primary-300 hover:bg-primary-50/20 transition-all cursor-pointer group"
              >
                <div className="absolute left-2.5 md:left-4 top-5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 group-hover:scale-125 transition-transform"></div>

                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date} {item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}